/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

import { ClientTokenEffect } from './client-token.effect';

export const effects: any[] = [ClientTokenEffect];

export * from './client-token.effect';
